import { SelectBase } from './SelectBase';
import { withSelect2 } from './withSelect2';
import getBrands from '~/api/getBrands';
import { s_r_n as lang } from '~/lang/ru';

export const Select2Brand = {
	name: 'Select2Brand',
	extends: SelectBase,
	mixins: [
		withSelect2(vm => ({
			placeholder: {
				id: '',
				text: lang('SELECT_BRAND'),
			},
			ajax: {
				transport: ({ data: { q: query } }, success, failure) => {
					return getBrands()
						.then((results) =>
							query ?
								results.filter(({ NAME }) => NAME.toLowerCase().includes(query.toLowerCase())) :
								results
						)
						.then(success)
						.catch(failure);
				},
				processResults: brands => ({
					results: brands.map(({ ID, NAME, ...rest }) => ({ id: ID, text: NAME, ...rest })),
				}),
			},
			width: '100%',
		})),
	],
	watch: {
		value: {
			handler: function (brandId, oldBrandId) {
				if (!brandId) return

				getBrands().then((brands) => {
					const brand = brands.find((brand) => brand.ID === brandId)

					if (!brand) return

					this.$options.select2.$element.append(new Option(brand.NAME, brand.ID))
				})
			},
			immediate: true,
		},
	},
}
